module.exports = __webpack_public_path__ + "img/DigitalAdhesive2.f5b58133.jpg";